export enum ConfirmDialogModeEnum {
  CLOSED = 'CLOSED',
  DELETE_STAGE = 'DELETE_STAGE',
  DELETE_STAGE_CONFIRMED = 'DELETE_STAGE_CONFIRMED',
  DELETE_STAGE_GROUP = 'DELETE_STAGE_GROUP',
  DELETE_STAGE_GROUP_CONFIRMED = 'DELETE_STAGE_GROUP_CONFIRMED',
  REMOVE_WIDGET = 'REMOVE_WIDGET',
  REMOVE_WIDGET_CONFIRMED = 'REMOVE_WIDGET_CONFIRMED',
  RESET_STAGE_TO_PUBLISH = 'RESET_STAGE_TO_PUBLISH',
  RESET_STAGE_TO_PUBLISH_CONFIRMED = 'RESET_STAGE_TO_PUBLISH_CONFIRMED',
  RESET_STAGE_TO_SAVED = 'RESET_STAGE_TO_SAVED',
  RESET_STAGE_TO_SAVED_CONFIRMED = 'RESET_STAGE_TO_SAVED_CONFIRMED',
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
  UNSAVED_CHANGES_CONFIRMED = 'UNSAVED_CHANGES_CONFIRMED',
}
